
<!-- fullUrl hdrFormat is routed here-->

<a href = {{h.extUrl}}>{{h.title}} </a>